import React, { useEffect } from 'react';
import logo from "../../../src/assets/icons/tennavi_scout_logo2026_4.png";
import './ServiceSuspended.css';

// Contact URLs for each user type
const CONTACT_URLS = {
  candidate: 'https://tayori.com/form/08ea498fea1a0ee034427c61264f0927cf3bf255/', 
  company: 'https://tayori.com/form/36cc156c10605d824dfbb0fe37447146a780cc16/',  
};

function getContactUrl() {
  const path = window.location.pathname.toLowerCase();
  const isCompany = path === '/company' || path.startsWith('/company/');
  return isCompany ? CONTACT_URLS.company : CONTACT_URLS.candidate;
}

export default function ServiceSuspended() {
  const contactUrl = getContactUrl();
  useEffect(() => {
    document.title = 'サービス一時休止のお知らせ｜転ナビ スカウト';

    // Ask search engines not to index the suspended page
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, nofollow';
    document.head.appendChild(robots);

    return () => {
      if (robots.parentNode) robots.parentNode.removeChild(robots);
    };
  }, []);

  return (
    <div className="ss-page">
      <main className="ss-main">
        <article className="ss-card" aria-labelledby="ss-title">
          <img
            className="ss-logo"
            src={logo}
            alt="転ナビ スカウト"
          />          

          <h1 id="ss-title" className="ss-title">
            サービス一時休止のお知らせ
          </h1>

          <p className="ss-subtitle">
            2026年11月1日より、サービスを一時休止しております。
          </p>

          <p className="ss-text">
            いつも「転ナビ スカウト」をご利用いただき、誠にありがとうございます。
            <br />
            より良いサービスをご提供するため、現在、サービス内容の見直し・改善を進めております。
          </p>

          <section className="ss-notice" aria-labelledby="ss-notice-title">
            <h2 id="ss-notice-title" className="ss-notice-title">
              休止期間中について
            </h2>
            <dl className="ss-notice-list">
              <dt>【サービスのご利用】</dt>
              <dd>新規登録・ログインを含む各サービスをご利用いただけません。</dd>

              <dt>【登録情報の取扱い】</dt>
              <dd>利用規約・プライバシーポリシー等に基づき適切に取り扱います。</dd>

              <dt>【今後の再開予定】</dt>
              <dd>サービスの再開時期は現在未定です。詳細については、本ページ等でお知らせいたします。
              </dd>
            </dl>
          </section>

          <section className="ss-contact" aria-labelledby="ss-contact-title">
            <h2 id="ss-contact-title" className="ss-contact-title">
              お問い合わせ
            </h2>
            <p className="ss-text">
              登録情報の取扱い、削除・利用停止等に関するお問い合わせは、下記窓口へ。
            </p>
            <div className="ss-actions">
              <a className="ss-btn" href={contactUrl} target='_blank' without rel="noreferrer">
                お問い合わせはこちら
              </a>
            </div>
          </section>
        </article>
      </main>

      <footer className="ss-footer">
        &copy; {new Date().getFullYear()} 転ナビ スカウト All Rights Reserved.
      </footer>
    </div>
  );
}
